import podOsElementsGlobalScript from '/home/runner/work/PodOS/PodOS/contacts/node_modules/@pod-os/elements/dist/collection/global.js';
import ionicCoreGlobalScript from '/home/runner/work/PodOS/PodOS/node_modules/@ionic/core/dist/collection/global/ionic-global.js';
export const globalScripts = () => {
  return Promise.all([
    ionicCoreGlobalScript(),
    podOsElementsGlobalScript(),
  ]);
};
